/**
 * Sesotho: Templates
 *
 * What this file covers: WhatsApp message templates and Meta's approval of them.
 *
 * Tone: Precise. Keep Meta's terms consistent (template, category, approved, rejected, paused). Explain Meta's
 * rules plainly, without blame.
 *
 * Sesotho: Everyday Sesotho as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const templates: Catalog = {
  'templates.title': 'Litemplate',
  'templates.actions.saveDraft': 'Boloka moralo',
  'templates.columns.category': 'Sehlopha',
  'templates.columns.note': 'Tlhokomeliso',
  'templates.empty': 'Ha ho litemplate hajoale.',
  'templates.loadError': 'Ha ea khona ho kenya litemplate.',
  'templates.modal.delete.title': 'Hlakola template?',
  'templates.toast.submitFailed': 'Ho romela ho hlolehile',
  'templates.view.backToAll': 'Litemplate tsohle',
  'templates.view.notFound': 'Template ha e fumanehe.',
  'templates.view.overview.metadata': 'Metadata',
  'templates.view.overview.preview': 'Ponelopele',
  'templates.view.tabs.components': 'Likarolo',
  'templates.view.tabs.variables': 'Tse fetohang',
  'templates.actions.create': 'Theha sethale',
  'templates.showingOf': 'Ho bontsšoa {{count}} ho {{total}}',
  'templates.note.underReview': 'E hlahlojoa ke Meta.',
  'templates.view.overview.businessName': 'Khoebo ea hao',
  'templates.view.overview.composer': 'Ngola molaetsa',
  'templates.header.label': 'Sehlooho',
  'templates.header.format.none': 'Ha ho sehlooho',
  'templates.header.format.text': 'Mongolo',
  'templates.header.format.image': 'Setshwantsho',
  'templates.header.format.video': 'Video',
  'templates.header.format.document': 'Tokomane'
};

export default templates;
